import { useContext } from 'react';
import LARDBContext from '../LARDBContext';

export function useLARDBContext() {
  return useContext(LARDBContext);
}
